import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/node_modules/next-themes/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["CSPostHogProvider"] */ "/app/src/hooks/usePostHog.tsx");
